import {HIDE_LOGIN_MODAL, HIDE_QUICK, SHOW_LOGIN_MODAL, SHOW_QUICK} from "../action_types";

export const showQuickView = product => ({type: SHOW_QUICK, payload: {product}});
export const hideQuickView = () => ({type: HIDE_QUICK});
export const showLoginModal = () => ({type: SHOW_LOGIN_MODAL})
export const hideLoginModal = () => ({type: HIDE_LOGIN_MODAL})